import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

//import { FirebaseProvider } from './contexts/FirebaseContext';
import { JWTProvider } from "./contexts/JWTContext";
import { GlobalValuesProvider } from "./contexts/globalValues";
//import { Auth0Provider } from "./contexts/Auth0Context";

import renderRoutes, { routes } from "./routes";
import { BASENAME } from "./config/constant";
import ErrorBoundary from "./views/errors/ErrorBoundary";

import PageTitleManager from "./components/PageTitleManager";

export const App = () => {
  return (
    <React.Fragment>
      <ErrorBoundary> 
        <Router basename={BASENAME}>
          <PageTitleManager />
          <JWTProvider>
            <GlobalValuesProvider>{renderRoutes(routes)}</GlobalValuesProvider>
          </JWTProvider>
        </Router>
      </ErrorBoundary>
    </React.Fragment>
  );
};

export default App;
